document.addEventListener('alpine:init', () => {
    Alpine.data('AllBlogs', (options = {}) => ({
        blogs: [],
        loading: true,
        error: null,
        page: 1,
        perPage: options.limit ?? 12,
        total: 0,

        get totalPages() {
            return Math.ceil(this.total / this.perPage);
        },

        async init() {
            const params = new URLSearchParams(window.location.search);
            this.page = parseInt(params.get('page')) || 1;
            await this.fetch();
        },

        async fetch() {
            this.loading = true;
            this.error = null;

            try {
                const response = await fetch('/alaska/public/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        controller: 'Blogs',
                        action: 'fetch',
                        filter: options.filter ?? null,
                        limit: this.perPage,
                        offset: (this.page - 1) * this.perPage,
                    }),
                });

                const result = await response.json();
                // console.log('blogs:', result);

                if (result.type === 'success') {
                    this.blogs = result.blogs;
                    this.total = result.total;
                } else {
                    this.error = result.message || 'Failed to load blogs.';
                }
            } catch (e) {
                this.error = 'Unable to load blog articles.';
                console.error('Blogs fetch error:', e);
            } finally {
                this.loading = false;
            }
        },

        async goToPage(p) {
            if (p < 1 || p > this.totalPages) return;
            this.page = p;

            const url = new URL(window.location);
            url.searchParams.set('page', p);
            window.history.pushState({}, '', url);

            await this.fetch();
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
    }));
});
